import {
  BROADCAST_SCROLL_TO_PAGE_ID_IN_FULL_BUNDLE,
  BROADCAST_SCROLL_TO_PAGE_ID_IN_LIGHT_BUNDLE,
  useFletchersBroadcast,
} from '@/broadcast';
import { AccessControlAction, AppRoutes, AppRoutesSearchParams } from '@/constants';
import { useAccessControl } from '@/hooks';
import {
  ActiveBundlePageType,
  ActiveBundlePageTypeKeys,
  selectCaseIdData,
  selectTimelineChronologyData,
  useAppSelector,
} from '@/store';
import { openNewTab } from '@/utils';
import { useSearchParams } from 'react-router';

export const useTimelineChronologyBundleNavigate = () => {
  const [searchParams] = useSearchParams();
  const currentSearchParams = searchParams.toString();
  const { sendMessageWithResponse } = useFletchersBroadcast();

  const caseId = useAppSelector(selectCaseIdData);
  const timelineChronologyData = useAppSelector(selectTimelineChronologyData);

  const isViewBundles = useAccessControl(AccessControlAction.VIEW_BUNDLES);

  const handleViewPageInFullBundle = (showPageIdInViewport: string) => {
    //** Ping request */
    sendMessageWithResponse(
      BROADCAST_SCROLL_TO_PAGE_ID_IN_FULL_BUNDLE,
      { showPageIdInViewport: showPageIdInViewport },
      1000,
    )
      .catch((error) => {
        console.info(`The full bundle tab does not exist`, error);

        if (caseId && timelineChronologyData && timelineChronologyData?.fullBundleId && showPageIdInViewport) {
          const newUrl = `/${AppRoutes.CaseList}/${caseId}/${AppRoutes.AiProcessedDocuments}/${AppRoutes.FullBundle}/${timelineChronologyData.fullBundleId}?${currentSearchParams}&${AppRoutesSearchParams.pageIdInViewportOnInit}=${showPageIdInViewport}`;
          return openNewTab(newUrl);
        }
      })
      .then((response) => {
        //** Pong response */
        if (response instanceof Window) {
          response.focus();
        }
      })
      .catch((error) => {
        if (error instanceof Error) {
          console.info(error.message);
        }
      });
  };

  const handleViewPageInLightBundle = (showPageIdInViewport: string) => {
    //** Ping request */
    sendMessageWithResponse(
      BROADCAST_SCROLL_TO_PAGE_ID_IN_LIGHT_BUNDLE,
      { showPageIdInViewport: showPageIdInViewport },
      1000,
    )
      .catch((error) => {
        console.info(`The light bundle tab does not exist`, error);

        if (caseId && timelineChronologyData && timelineChronologyData?.lightBundleId && showPageIdInViewport) {
          const newUrl = `/${AppRoutes.CaseList}/${caseId}/${AppRoutes.AiProcessedDocuments}/${AppRoutes.LightBundle}/${timelineChronologyData.lightBundleId}?${currentSearchParams}&${AppRoutesSearchParams.pageIdInViewportOnInit}=${showPageIdInViewport}`;
          return openNewTab(newUrl);
        }
      })
      .then((response) => {
        //** Pong response */
        if (response instanceof Window) {
          response.focus();
        }
      })
      .catch((error) => {
        if (error instanceof Error) {
          console.info(error.message);
        }
      });
  };

  const handlePageClick = ({
    activeBundlePageType,
    pageId,
  }: {
    activeBundlePageType: ActiveBundlePageTypeKeys;
    pageId: string;
  }) => {
    if (activeBundlePageType === ActiveBundlePageType.FULL && isViewBundles) {
      handleViewPageInFullBundle(pageId);
    }
    if (activeBundlePageType === ActiveBundlePageType.LIGHT && isViewBundles) {
      handleViewPageInLightBundle(pageId);
    }
  };

  return { handlePageClick, isViewBundles };
};
